module.exports = __webpack_public_path__ + "13bb9e5ef5f6525c201508a661c72eec.svg";